import styled, { css } from "styled-components";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import {
    CHANNEL_COVER_ASPECT_RATIO,
    CHANNEL_COVER_BACKGROUND_STYLES,
} from "@Utils/channelCover";

interface IGradientProps {
    hue: number;
}
interface IDescriptionProps {
    isSticky: boolean;
}

export const UploadCoverWrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
`;
export const ChannelCover = styled.div<{
    url?: string;
}>`
    background-image: url(${(props) => props.url});
    height: 100%;
    width: 100%;
    background-size: ${CHANNEL_COVER_BACKGROUND_STYLES.backgroundSize};
    background-repeat: ${CHANNEL_COVER_BACKGROUND_STYLES.backgroundRepeat};
    background-position: ${CHANNEL_COVER_BACKGROUND_STYLES.backgroundPosition};
    border-radius: 8px 8px 0 0;
`;

export const Gradient = styled.div<IGradientProps>(
    ({ hue }) => css`
        background: linear-gradient(
            20deg,
            hsl(${hue}, 60%, 65%),
            hsl(${hue - 305}, 64%, 60%)
        );
        height: 100%;
        width: 100%;
        border-radius: 8px 8px 0 0;
    `
);

export const StyledChannelHeaderWrapper = styled.div`
    background: white;
    display: flex;
    flex-direction: column;
    min-height: 300px;
    border-radius: 8px;
    margin-bottom: 20px;
`;

export const StyledChannelHeaderCover = styled.div`
    aspect-ratio: ${CHANNEL_COVER_ASPECT_RATIO};
    width: 100%;
    position: relative;
`;

export const StyledAvatar = styled(Avatar)((props) => ({
    src: props.src,
    alt: props.alt,
}));

export const StyledAvatarContainer = styled.div<{
    isSticky: boolean;
    widthElement: number;
}>`
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: 2px solid white;
    position: absolute;
    top: -3.75rem;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    background: white;

    @media (min-width: 501px) {
        left: 1rem;
        margin-left: 0;
        margin-right: 0;
    }

    ${({ isSticky }) =>
        isSticky &&
        css`
            width: 80px;
            height: 80px;
            top: 0;
        `}
`;

export const StyledBadgeAvatar = styled(Avatar)(
    () => css`
        cursor: pointer;
        height: 20px;
        width: 20px;
    `
);

export const StyledChannelHeaderInfo = styled.div<{
    isSticky: boolean;
    widthElement: number;
    hasAvatar?: boolean;
}>`
    position: relative;
    @media (min-width: 501px) {
        padding-left: ${({ hasAvatar }) => (hasAvatar ? "145px" : "0")};
    }

    ${({ isSticky, widthElement, hasAvatar }) =>
        isSticky &&
        css`
            position: fixed;
            top: 5em;
            width: ${widthElement
                ? `${widthElement - (hasAvatar ? 145 : 0)}px`
                : "auto"};
            transition: all 0.5s ease;
            animation: smoothScroll 1s forwards;
            z-index: 1000;
            background-color: white;
            border-radius: 8px 8px 8px 8px;
            box-shadow: 0 0 1px rgba(53, 52, 52, 0.3294117647);

            @media (max-width: 500px) {
                top: 5.4em;
                width: 100%;
                left: 0;
                right: 0;
                border-radius: 0;
            }
        `}
`;

export const StyledInfoChannel = styled.div<{
    hasAvatar?: boolean;
    $reserveAction?: boolean;
}>`
    height: inherit;
    display: flex;
    flex-direction: column;
    padding: ${({ hasAvatar }) => (hasAvatar ? "80px 20px 16px" : "16px 20px")};
    box-sizing: border-box;
    @media (min-width: 501px) {
        padding: 8px 20px 16px;
        text-align: left;
    }
    /* Room for the Present Mode button (shown from MUI's md breakpoint): the title can't
       run under it, and the button gets clear space above and below. */
    ${({ $reserveAction }) =>
        $reserveAction &&
        css`
            @media (min-width: 900px) {
                min-height: 104px;
                justify-content: center;
                padding-top: 16px;
                padding-bottom: 16px;
                padding-right: 260px;
            }
        `}
`;

export const StyledHeader = styled.h1(
    ({ theme }) => css`
        color: ${theme.palette.common.blue};
        margin: 0;
        font-size: 26px;
        line-height: 1.5;
        font-weight: 600;
        overflow-wrap: anywhere;
        @media (max-width: 500px) {
            font-size: clamp(18px, 4.2vw, 22px);
        }
    `
);

export const StyledDescription = styled.p<IDescriptionProps>(
    ({ theme, isSticky }) => css`
        color: ${theme.palette.common.darkGray};
        font-size: 1rem;
        line-height: 1.5;
        overflow-wrap: anywhere !important;
        margin: 0;
        @media (max-width: 500px) {
            font-size: clamp(14px, 4vw, 16px);
            ${isSticky &&
            css`
                display: none;
            `}
        }
    `
);
export const StyledChannelHeaderDescription = styled.span(
    ({ theme }) => css`
        @media (max-width: 500px) {
            font-size: 13px;
        }
    `
);

/** Sits at the right of the title strip, vertically centred on the title block. */
export const StyledPresentModeAction = styled(Box)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 40px;
    z-index: 1;
`;
